import React, { useEffect, useState } from 'react';
import moment from 'moment';

interface CountdownProps {
  startTime: string;
  duration: number;
  onExpire: () => void;
  unit?: 'minutes' | 'seconds';
  emptyMessage?: string;
}

const Countdown: React.FC<CountdownProps> = ({
  startTime,
  duration,
  onExpire,
  unit = 'minutes',
  emptyMessage = 'El chat ha finalizado',
}) => {
  const [remaining, setRemaining] = useState<number>(0);
  const [expired, setExpired] = useState<boolean>(false);

  useEffect(() => {
    const now = moment();
    const end = moment(startTime).add(duration, unit);
    const initialDiff = end.diff(now, 'seconds');

    if (initialDiff <= 0) {
      setExpired(true);
      setRemaining(0);
      onExpire();
      return;
    }

    setRemaining(initialDiff);

    const interval = setInterval(() => {
      const now = moment();
      const end = moment(startTime).add(duration, unit);
      const diff = end.diff(now, 'seconds');

      if (diff <= 0) {
        clearInterval(interval);
        setExpired(true);
        setRemaining(0);
        onExpire();
      } else {
        setRemaining(diff);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime, duration, unit]);

  const formatTime = (seconds: number) => {
    const duration = moment.duration(seconds, 'seconds');
    const minutes = Math.floor(duration.asMinutes());
    const secs = duration.seconds();
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div>
      {expired ? (
        <small>{emptyMessage}</small>
      ) : (
        <small>Tiempo restante: {formatTime(remaining)}</small>
      )}
    </div>
  );
};

export default Countdown;
